// Opcoes de SALA PRA AULA, num lugar so. A API recusa aula, turma e matricula em sala
// desativada ou sem o uso "Aula" (`assertRoomForLessons`, apps/api/src/services/catalog.ts):
// oferecer no seletor uma sala que vai voltar 409 e o mesmo defeito de nao ter o cadastro na
// tela, so que mais caro (o usuario preenche o formulario inteiro pra levar a recusa no fim).
// `keep` mantem na lista a sala JA gravada no registro que esta sendo editado, pra ela nao
// sumir do campo sem o usuario perceber quando alguem desativa a sala ou tira o uso "Aula".
// Sala de ensaio tem lista propria (BookingDialog filtra por practice/rental).
import type { RefOption } from './RefSelect'

export type RoomLike = { id: string; name: string; active: boolean; usage?: { lessons: boolean } | null }

export function lessonRoomOptions(rooms: RoomLike[] | undefined | null, keep?: string | null): RefOption[] {
  return (rooms ?? [])
    .filter((r) => (r.active && r.usage?.lessons !== false) || (!!keep && r.id === keep))
    .map((r) => ({ id: r.id, label: r.name }))
}
